// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { cartTotalStyles } from "@guestsupply/Overrides/Widgets/CheckoutShipping/CheckoutShippingCartTotal";
import { css } from "styled-components";

cartTotalStyles.container = {
    css: css`
        display: flex;
        flex-direction: column;
        gap: 16px;
    `,
};
cartTotalStyles.buttonsContainer = {
    css: css`
        display: flex;
        flex-direction: column;
        gap: 12px;
    `,
};
cartTotalStyles.backToCartButton = {
    variant: "secondary",
    css: css`
        width: 100%;
    `,
};
cartTotalStyles.continueButton = {
    variant: "primary",
    css: css`
        width: 100%;
    `,
};
